import React from 'react'; 
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import styles from './searchBar.module.css';
import { textTransform } from '@mui/system';

interface SearhBarProps {
    onChange: (value: string) => void;
    transformUppercase?: boolean;
    defaultValue?: string;
}

const SearchBar = (props: SearhBarProps) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [value, setValue] = React.useState(props.defaultValue);

    const handleChange = (value: string) => {
        if (props.transformUppercase) {
            value = value.toUpperCase();
        }
        setValue(value);
        props.onChange(value);
    };

    let searchBarInputProps : any = {};
    if (props.transformUppercase) {
        searchBarInputProps['style'] = { textTransform: 'uppercase '};
    }

    const handleClearClick = () => {
        setValue("");
        props.onChange("");
    };

    return (
        <div className={styles.searchBarContainer}>
            <TextField
                className={styles.searchBar} 
                variant="outlined" 
                label="Search" 
                onChange={(event) => handleChange(event?.target.value)}
                defaultValue={props.defaultValue}
                value={value}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <IconButton
                          sx={{ visibility: value ? "visible" : "hidden" }}
                          onClick={handleClearClick}
                        >
                          <ClearIcon />
                        </IconButton>
                    ),
                    style: {
                        textTransform: 'uppercase'
                    }
                }}
                inputProps={searchBarInputProps}
            >
            </TextField>
        </div>
    );
}

export default SearchBar;
